import { render } from "./CompanyNewsDetial.vue?vue&type=template&id=f78641fa&scoped=true"
import script from "./CompanyNewsDetial.vue?vue&type=script&lang=js"
export * from "./CompanyNewsDetial.vue?vue&type=script&lang=js"

import "./CompanyNewsDetial.vue?vue&type=style&index=0&id=f78641fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f78641fa"]])

export default __exports__